<template>
  <div id="tour-courses-page" class="flex flex-1 flex-col space-y-2">
    <div class="flex flex-1">
      <DashboardHeaderTab
        :title="'Courses'"
        :tabs="tabs"
        :activeTab="activeTab"
        :setActiveTab="setActiveTab"
        :toggleSidebar="toggleSidebar"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import DashboardHeaderTab from '@/components/DashBoard/common/DashboardHeaderTab.vue';
import { useTabs } from '@/composables/useTabs';
import { useTertiaryDashboard } from '@/composables/useTertiaryDashboard';
import { useUserStore } from '@/store/userStore';

const toggleSidebar = inject<() => void>('toggleSidebar', () => {});
const userStore = useUserStore();
const currentUser = computed(() => userStore.currentUser);
const { courseTabs } = useTertiaryDashboard(currentUser);

const tabs = computed(() => courseTabs.value);
const { activeTab, setActiveTab } = useTabs(tabs);
</script>
